import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=76402790&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76402790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76402790')) {
      api.createRecord('76402790', component.options)
    } else {
      api.reload('76402790', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=76402790&scoped=true&", function () {
      api.rerender('76402790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/result/Error.vue"
export default component.exports